module.exports = "../images/local-business.jpg?v=5396489";